import { TablesInputProvider, useTablesInput } from 'providers/TablesInputProvider';
import TablesScreen from 'screens/TablesScreen';
import { HeroPage } from 'config/hero-covers';
import useOfflineQuery from 'hooks/useOfflineQuery';
import { useSalesQuery } from 'generated/graphql';

const SalesInner = () => {
  const { input, profileID, isQueryPaused } = useTablesInput();
  const [result, refetch] = useOfflineQuery('sales-query', useSalesQuery, {
    variables: { input, profileID },
    pause: isQueryPaused,
    returnCachedDataWhileFetching: true,
  });
  return <TablesScreen heroPage={HeroPage.Sales} result={result} refetch={refetch} dataKey="sales" />;
};

const SalesScreen = () => (
  <TablesInputProvider>
    <SalesInner />
  </TablesInputProvider>
);

export default SalesScreen;
